// generated from 4_684 samples

import { z } from "zod";
import { common } from "../common";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const productPurchasedSinceFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("product_purchased_since_filter"),
  // undefined: 4_654 (99.36%), defined 30 (0.64%)
  blocklisted: z.literal(true).optional(),
  comparison_key: z.enum([
    "4", // 2_251 (48.06%)
    "6", // 1_507 (32.17%)
    "3", // 534 (11.40%)
    "5", // 392 (8.37%)
  ]),
  display_name: z.string(),
  // undefined: 1_849 (39.47%), defined 2_835 (60.53%)
  raw_value: z
    .union([
      // number samples: 1_967 (69.38%)
      // integer: 1_653 (84.04%)
      // avg: 129.81, min: 0.0035, max: 1092
      z.number().nonnegative(),
      // string samples: 868 (30.62%)
      common.date,
    ])
    .optional(),
  value: z.union([
    // number samples: 3_758 (80.23%)
    // integer: 3_414 (90.85%)
    // avg: 114.65, min: 0.0035, max: 1096
    z.number().nonnegative(),
    // string samples: 926 (19.77%)
    common.date,
  ]),
  varies_by_app_group: z.literal(true),
});
